import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/locationgcc/sa/saudiback.webp";
import Bannerfrom from "../../components/bannerfrom";

function Banner({ handleShow }) {
  return (
    <div
      className="locationgcc_banner saudia_mob_banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Saudi Arabia">
                <h1>
                  Top Mobile App Development Company in Riyadh Saudi Arabia
                </h1>
              </div>
              <p className="main_para">
                TekRevol, a leading mobile app development company, takes pride
                in offering mobile app development services in Saudi Arabia,
                covering both custom Android and iOS applications requirements.
                Our{" "}
                <Link to="/hire-mobile-app-developers-in-saudi-arabia">
                  app developers in Saudi Arabia{" "}
                </Link>
                are utilizing modern technologies to build full-fledged mobile
                solutions. As a custom mobile app development company, our goal
                is to assist businesses in transforming through innovative,
                robust, and leading mobile app development taking their ROI to
                the next level.
              </p>
              <a
                style={{ cursor: "pointer" }}
                onClick={handleShow}
                href="javascript:void(0)"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Schedule a Call
              </a>
              <Link
                to="/app-cost-calculator"
                className="border_btn dark_btn mx-xl-3 mx-md-0"
                aria-label="TekRevol Contact"
              >
                Calculate Your App Cost
              </Link>
            </div>
          </Col>
          <Col xs={12} md={5} lg={5} xl={6} xxl={6} className="my-auto">
            {/* <StaticImage
              src="../../../images/locationgcc/sa/saudibanner.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={776}
              height={654}
            /> */}
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
